export const getSectionNameByPath = () => {
  const pathLists = {
    changeAccount: { path: '/app/change-account', section: 'Change Account' },
    home: { path: '/app/home', section: 'Home' },
    announcement: { path: '/app/announcement', section: 'Announcement' },
    classifieds: { path: '/app/community/classifieds', section: 'Classifieds' },
    payments: { path: '/app/payments', section: 'Payments' },
    messages: { path: '/app/messages', section: 'Messages' },
    community: { path: '/app/community', section: 'Community' },
    events: { path: '/app/community/events', section: 'Events' },
    services: { path: '/app/community/property-services', section: 'Services' },
    clubs: { path: '/app/community/clubs', section: 'Clubs' },
    apartment: { path: '/app/apartment', section: 'Apartment' },
    documents: { path: '/app/apartment/documents', section: 'Documents' },
    emergencyContacts: {
      path: '/app/apartment/emergency-contacts',
      section: 'Emergency Contacts',
    },
    utilities: { path: '/app/apartment/utilities', section: 'Utilities' },
    maintenance: { path: '/app/apartment/maintenance', section: 'Maintenance' },
    inspections: { path: '/app/apartment/inspections', section: 'Inspections' },
    insurance: { path: '/app/apartment/insurance', section: 'Insurance' },
    guestList: { path: '/app/apartment/guest-list', section: 'Guest List' },
    renewals: { path: '/app/apartment/renewals', section: 'Renewals' },
    feedback: { path: '/app/feedback', section: 'Feedback' },
    setting: { path: '/app/setting', section: 'Setting' },
    languageSettings: {
      path: '/app/language-settings',
      section: 'Language Settings',
    },
    accountSettings: {
      path: '/app/account-settings',
      section: 'Account Settings',
    },
    privacyPolicies: {
      path: '/app/privacy-policies',
      section: 'Privacy Policies',
    },
  }

  const sectionPathList = Object.values(pathLists).filter(
    pathList => window.location.pathname.indexOf(pathList.path) !== -1,
  )

  if (Object.values(sectionPathList).length > 0) {
    return sectionPathList[0].section || ''
  }

  return ''
}
